module.exports = __webpack_public_path__ + "static/media/upArrow_disabled.bac264ce.svg";